x<template>
  <div>
    <Head :title="`${data.first_name} ${data.last_name}`"/>
    <h1 class="mb-8 text-3xl font-bold">
      <span v-if="viaVolunteer" class="text-gray-400">{{ $t('volunteers.volunteers') }}</span>
      <Link v-else class="text-gray-400 hover:text-gray-600" href="/volunteers">{{ $t('volunteers.volunteers') }}</Link>
      <span class="text-gray-400 font-medium">/ </span>
      {{ data.first_name }} {{ data.last_name }}
    </h1>
    <div class="grid gap-4 xl:grid-cols-2 grid-cols-1">
      <detail-view :data="viewData">
        <template #default="item">
          <div v-if="item.props.key === 'stats_treatments'" class="flex">
            <progressbar :current="item.props.value.total" :max="item.props.value.max"/>
          </div>
          <div v-if="item.props.key === 'login'" class="flex">
            <Link
              class="btn-indigo inline-flex items-center lg:mb-0 max-w-md"
              :href="item.props.value.link"
            >
              <span v-if="item.props.value.has_login">{{ $t('volunteers.update_login') }}</span>
              <span v-else>{{ $t('volunteers.create_login') }}</span>
            </Link>
          </div>

          <badge
            v-if="item.props.key === 'authorization_date'" class="flex"
            :text="$filters.formatDate(data.authorization_date)"
            :color="$functions.getDateColor(data.authorization_date)"
          />
          <span v-if="item.props.key === 'active' || item.props.key === 'visitor'" class="inline-block">
            <yes-no :value="!!item.props.value"/>
          </span>
        </template>
      </detail-view>
      <div v-if="!viaVolunteer">
        <Table
          :resource="treatments"
          name="treatments"
          class="custom-table-layout rounded"
        >
          <template #cell(date_open)="{ item: treatment }">
            {{ $filters.formatDate(treatment.date_open) }}
          </template>
          <template #cell(status)="{ item: treatment }">
            <status-badge :status="treatment.status"/>
          </template>
        </Table>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import DetailView from '@/Shared/DetailView'
import Progressbar from '@/Shared/Progressbar'
import Badge from '@/Shared/Badge'
import { Table } from '@/Shared/Table/main'
import StatusBadge from '@/Shared/StatusBadge'
import YesNo from '@/Shared/YesNo'

export default {
  components: {
    Head,
    Link,
    DetailView,
    Progressbar,
    Badge,
    Table,
    StatusBadge,
    YesNo,
  },
  layout: Layout,
  props: {
    data: Object,
    treatments: Object,
    viaVolunteer: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      viewData: {
        items: [
          {
            label: this.$t('applicants.first_name'),
            value: this.data.first_name,
          },
          {
            label: this.$t('applicants.last_name'),
            value: this.data.last_name,
          },
          {
            label: this.$t('applicants.phone'),
            value: this.data.phone,
          },
          {
            label: this.$t('users.email'),
            value: this.data.email,
          },
          {
            label: this.$t('applicants.languages'),
            value: this.data.languages?.join(', '),
          },
          {
            label: this.$t('applicants.address'),
            value: (this.data.street) ? (this.data.street ?? '') + ' ' + (this.data.street_number ?? '') + ', ' + (this.data.zip_code ?? '') + ' ' + (this.data.city ?? '') : null,
          },
          {
            label: this.$t('applicants.date_birth'),
            value: this.$filters.formatDate(this.data.date_birth),
          },
          {
            label: this.$t('volunteers.date_entry'),
            value: this.$filters.formatDate(this.data.date_entry),
          },
          {
            label: this.$t('volunteers.date_exit'),
            value: this.$filters.formatDate(this.data.date_exit),
          },
          {
            key: 'authorization_date',
            label: this.$t('users.authorization_date'),
            value: this.$filters.formatDate(this.data.authorization_date),
          },
          {
            key: 'visitor',
            label: this.$t('volunteers.visitor'),
            value: this.data.visitor,
          },
          {
            key: 'active',
            label: this.$t('volunteers.active'),
            value: this.data.status,
          },
          {
            key: 'stats_treatments',
            label: this.$t('volunteers.max_treatments'),
            value: this.data.stats_treatments,
          },
          {
            hide: this.viaVolunteer,
            key: 'login',
            label: this.$t('volunteers.has_login'),
            value: this.data.login,
          },
        ],
        updateLink: (this.viaVolunteer) ? '/volunteer/edit':`/volunteers/${this.data.id}/edit`,
        header: {
          title: 'Volunteer Information',
          text: 'Personal details and contact information.',
        },
      },
    }
  },
}
</script>
